import React from 'react'
import 'react-table/react-table.css'
import {DEBT_RECOVERY, DEBT_RECOVERY_PERCENT, DEBT_RECOVERY_TOTAL} from '../utils/constants'
import * as RequestUtils from '../service/data-info-chart/requestsUtil'
import * as Formatter from '../utils/formatters'
import classNames from 'classnames'
import * as cbu from '../utils/checkBusinessUnit'
import Loader from 'react-loader'

class DebtRecovery extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      data: [], dataPercent: [], total: {}, pages: '', message: '', date: this.props.date, dataTotal: '',
      loaded1: false, loaded2: false, loaded3: false
    }
    this.data = []
    this.dataPercent = []
  };

  componentDidMount() {

    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.state.date
    }

    RequestUtils.postFetch(DEBT_RECOVERY, params).then((data) => {
      this.setState({data: data, loaded1: true})
    })
    RequestUtils.postFetch(DEBT_RECOVERY_PERCENT, params).then((data) => {
      this.setState({dataPercent: data, loaded2: true})
    })
    RequestUtils.postFetch(DEBT_RECOVERY_TOTAL, params).then((data) => {
      this.setState({dataTotal: data, loaded3: true})
    })
  }

  componentWillReceiveProps(nextProps) {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: this.props.date
    }

    RequestUtils.postFetch(DEBT_RECOVERY, params).then((data) => {
      this.setState({data: data})
    })
    RequestUtils.postFetch(DEBT_RECOVERY_PERCENT, params).then((data) => {
      this.setState({dataPercent: data})
    })
    RequestUtils.postFetch(DEBT_RECOVERY_TOTAL, params).then((data) => {
      this.setState({dataTotal: data})
    })
  }

  componentWillMount() {
  }

  render() {

    const tableClass = classNames({
      'table': true,
      'table-striped': true,
      'table-bordered': true,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    })

    let rows = this.state.data.map((accounts) => {
      return <tr>
        <td>{accounts.type}</td>
        <td>{accounts.accounts}</td>
        <td>{Formatter.formatNumberMoney(accounts.amount)}</td>
      </tr>
    })

    rows.pop()

    let rowsPercent = this.state.dataPercent.map((accounts) => {
      return <tr>
        <td>{accounts.type}</td>
        <td>{accounts.accounts}</td>
        <td>{Formatter.formatNumberMoney(accounts.amount)}</td>
        <td>{accounts.porcent}</td>
        <td>{Formatter.formatNumberMoney(accounts.amountPaid)}</td>
        <td>{accounts.porcentPaid}</td>
      </tr>
    })

    rowsPercent.pop()

    var rowTotal
    var rowPercentTotal
    var colsTotal

    if (this.state.data.length !== 0) {
      rowTotal = <tr>
        <td><b>{this.state.data[5].type}</b></td>
        <td><b>{this.state.data[5].accounts}</b></td>
        <td><b>{Formatter.formatNumberMoney(this.state.data[5].amount)}</b></td>
      </tr>
    } else {
      rowTotal = ''
    }

    if (this.state.dataPercent.length !== 0) {
      rowPercentTotal = <tr>
        <td><b>{this.state.dataPercent[7].type}</b></td>
        <td><b>{this.state.dataPercent[7].accounts}</b></td>
        <td><b>{Formatter.formatNumberMoney(this.state.dataPercent[7].amount)}</b></td>
        <td><b>{this.state.dataPercent[7].porcent}</b></td>
        <td><b>$0</b></td>
        <td><b>0%</b></td>
      </tr>
    } else {
      rowPercentTotal = ''
    }

    colsTotal = <tr style={{height: '30px'}}>
      <th className={'align-middle'} style={{width: '35%'}}>Total de cuentas</th>
      <th className={'align-middle'} style={{width: '33%'}}>{this.state.dataTotal.accounts}</th>
      <th className={'align-middle'}>{Formatter.formatNumberMoney(Number(this.state.dataTotal.amount))}</th>
    </tr>

    return (
      <div>
        <div id="adj-table" className="container-fluid">
          <div className="container-fluid mt-2">
            <div className="masonry grid full-width scrollx">
              <Loader loaded={this.state.loaded1} top="50%">
                <table className={tableClass}>
                  <thead className={'p-2'} style={{color: '#FFF', backgroundColor: '#78909C'}}>
                  <tr style={{height: '30px'}}>
                    <th className={'align-middle'} style={{width: '35%'}}>Estatus</th>
                    <th className={'align-middle'} style={{width: '33%'}}>Número de cuentas</th>
                    <th className={'align-middle'}>Montos de adeudo</th>
                  </tr>
                  </thead>
                  <tbody>
                  {rows}
                  {rowTotal}
                  </tbody>
                </table>
              </Loader>
            </div>
          </div>
          <div className="container-fluid mt-2">
            <div className="masonry grid full-width scrollx">
              <Loader loaded={this.state.loaded2} top="50%">
                <table className={tableClass}>
                  <thead className={'p-2'} style={{color: '#FFF', backgroundColor: '#78909C'}}>
                  <tr style={{height: '30px'}}>
                    <th className={'align-middle'} style={{width: '35%'}}>Estatus</th>
                    <th className={'align-middle'} style={{width: '33%'}}>Número de cuentas</th>
                    <th className={'align-middle'}>Montos de adeudo</th>
                    <th className={'align-middle'}>%</th>
                    <th className={'align-middle'}>Monto pagado</th>
                    <th className={'align-middle'}>%</th>
                  </tr>
                  </thead>
                  <tbody>
                  {rowsPercent}
                  {rowPercentTotal}
                  </tbody>
                </table>
              </Loader>
            </div>
          </div>
          <div className="container-fluid mt-2">
            <div className="masonry grid full-width scrollx">
              <Loader loaded={this.state.loaded3} top="50%">
                <table className={tableClass}>
                  <thead className={'p-2'} style={{color: '#FFF', backgroundColor: '#78909C'}}>
                  {colsTotal}
                  </thead>
                </table>
              </Loader>
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default DebtRecovery



// WEBPACK FOOTER //
// ./src/tables/debtRcovery.js